import TomSelect from "tom-select";

const selects = document.querySelectorAll<HTMLSelectElement>(".f-select__select");

selects.forEach(select => {
  new TomSelect(select, {
    placeholder: "",
    persist: false,
    render: {
      no_results: null,
      option_create: null
    }
  });
})
